import { HAIR } from './settings/hair';
import { FACE } from './settings/face';
import { SHIRT } from './settings/shirt';
import { PANTS } from './settings/pants';
import { OPTIONS } from '@/utils/common';
import {
  filterHairForScarf,
  filterFaceForScarf,
  filterOutfitForScarf
} from './settings/outfitConstraints';
import SkinAvatar from './Options/SkinAvatar';
import ColorAvatar from './Options/ColorAvatar';
import DetailsAvatar from './Options/DetailsAvatar';
import AccessoriesAvatar from './Options/AccessoriesAvatar';
import IconFace from '@/assets/images/icons/icon-face.svg?component';
import IconWear from '@/assets/images/icons/icon-wear.svg?component';
import type { IAvatarOptions, ITabOption, ISetOption } from './types';
import IconFrame from '@/assets/images/icons/icon-frame.svg?component';
import IconPerson from '@/assets/images/icons/icon-person.svg?component';
import IconGlasses from '@/assets/images/icons/icon-glasses.svg?component';
import IconTrousers from '@/assets/images/icons/icon-trousers.svg?component';
import IconScissors from '@/assets/images/icons/icons-scissors.svg?component';

type ITabProps = {
  toggleColorPanel: (visible: boolean) => void;
  setFocus?: (focus: boolean) => void;
  options: IAvatarOptions;
  setOption: ISetOption;
};

export const GET_TAB_OPTIONS = ({
  toggleColorPanel,
  setOption,
  setFocus,
  options,
  translations
}: ITabProps & { translations: any }): ITabOption[] => {
  const { person, colour, haircut, facial, top, bottom, kader } = translations;

  return [
    {
      label: person,
      icon: <IconPerson />,
      value: OPTIONS.details,
      component: (
        <DetailsAvatar
          options={options}
          setOption={setOption}
          setFocus={setFocus}
        />
      )
    },
    {
      label: colour,
      icon: <IconFace />,
      value: OPTIONS.skinColor,
      component: (
        <SkinAvatar
          option={options[OPTIONS.skinColor]}
          name={OPTIONS.skinColor}
          setOption={setOption}
        />
      )
    },
    {
      label: haircut,
      value: OPTIONS.hair,
      icon: <IconScissors />,
      component: (
        <AccessoriesAvatar
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          setOption={setOption}
          name={OPTIONS.hair}
          keysItem="hair"
          label="Haircut"
          list={filterHairForScarf(HAIR, options[OPTIONS.elements])}
        />
      )
    },
    {
      label: facial,
      value: OPTIONS.face,
      icon: <IconGlasses />,
      component: (
        <AccessoriesAvatar
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          setOption={setOption}
          name={OPTIONS.face}
          keysItem="face"
          label="Facial"
          list={filterFaceForScarf(FACE, options[OPTIONS.elements])}
        />
      )
    },
    {
      label: top,
      icon: <IconWear />,
      value: OPTIONS.shirt,
      component: (
        <AccessoriesAvatar
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          setOption={setOption}
          name={OPTIONS.shirt}
          keysItem="shirt"
          label="Top"
          list={filterOutfitForScarf(SHIRT, 'shirt', options[OPTIONS.elements])}
        />
      )
    },
    {
      label: bottom,
      value: OPTIONS.pants,
      icon: <IconTrousers />,
      component: (
        <AccessoriesAvatar
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          setOption={setOption}
          name={OPTIONS.pants}
          keysItem="pants"
          label="Bottom"
          list={filterOutfitForScarf(PANTS, 'pants', options[OPTIONS.elements])}
        />
      )
    },
    {
      label: kader,
      icon: <IconFrame />,
      value: OPTIONS.favoriteColor,
      component: (
        <ColorAvatar
          option={options[OPTIONS.favoriteColor]}
          name={OPTIONS.favoriteColor}
          setOption={setOption}
        />
      )
    }
  ];
};
